import { defineMessages } from 'react-intl';

export const freightCarrierDetailsModalMessages = defineMessages({
  title: {
    defaultMessage: 'Carrier Details',
    id: 'CORZvM',
    description: 'Title of the freight carrier details modal',
  },
  terminalInformation: {
    defaultMessage: 'Terminal Information',
    id: '84eQQW',
    description: 'Section header for terminal address information',
  },
  pickupLabel: {
    defaultMessage: 'Pickup',
    id: '/gZUI5',
    description: 'Label for the pickup terminal column',
  },
  deliveryLabel: {
    defaultMessage: 'Delivery',
    id: 'qktLPC',
    description: 'Label for the delivery terminal column',
  },
  transitInformation: {
    defaultMessage: 'Transit Information',
    id: 'ZIDvJg',
    description: 'Section header for transit time information',
  },
  estimatedTransit: {
    defaultMessage: 'Estimated Days in Transit: {days, plural, one {# day} other {# days}}',
    id: 'cdPmYX',
    description: 'Estimated transit time in days',
  },
  liabilityLimits: {
    defaultMessage: 'Maximum Limits of Liability',
    id: 'KgZJtJ',
    description: 'Section header for maximum liability limits',
  },
  liabilityNew: {
    defaultMessage: 'New: {amount}',
    id: 'guGikU',
    description: 'Maximum liability for new items',
  },
  liabilityUsed: {
    defaultMessage: 'Used: {amount}',
    id: 'VpaJ1J',
    description: 'Maximum liability for used items',
  },
  close: {
    defaultMessage: 'Close',
    id: 'fq0ymw',
    description: 'Button to close the carrier details modal',
  },
});
